<template lang="pug">
    .landingpage
        .section(v-if="sections.length" v-for="(section, index) in sections" :key="section.id" :class="section.key")
            Heading(
                v-if="section.key === 'heading'" :section="section"
                heading-class="is-size-2-desktop is-size-3-tablet is-size-4-mobile has-text-weight-light"
                sub-heading-class="is-size-6 is-uppercase has-text-primary"
            )
            Slider(v-if="section.key === 'slider'" :section="section")
            CategoryPosts(
                v-if="section.key === 'categoryposts'"
                :section="section"
                :per-page="4"
                orientation="horizontal"
            )
            ImageSection(v-if="section.key === 'image'" :section="section")
            Banners(v-if="section.key === 'banners'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
            SocialWall(v-if="section.key === 'socialwall'")
        .supporters.container
            .columns
                .column.is-one-fourth
                    h4 Gefördert von
                    .wrapper
                        a(href="https://www.mkw.nrw/")
                            img(src="@/assets/mkw-branding.png")
                .column.is-one-fourth
                    h4 Ein Projekt des
                    .wrapper
                        a(href="https://guetesiegelverbund.de/")
                            img(src="@/assets/guetesiegelverband.svg")
                .column.is-half
                    h4 Kooperation mit
                    .columns
                        .column.is-half
                            .wrapper
                                a(href="https://www.supportstelle-weiterbildung.nrw.de/")
                                    img(src="@/assets/RZ_RGB_QUA-LiS-Logo-Supportstelle_pfade.png")
                        .column.is-half
                            .wrapper
                                a(href="https://laaw.nrw/")
                                    img(src="@/assets/laaw_lg_nrw_rgbneu.jpg")
                    .columns
                        .column.is-half
                            .wrapper
                                a(href="https://vhs.bochum.de/")
                                    img(src="@/assets/LOGO_VHS_blau_rot.jpg")
                        .column.is-half
                            .wrapper
                                a(href="https://karl-arnold-stiftung.de")
                                    img(src="@/assets/Logo_KAST.jpg")
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import Slider from '@/components/Slider'
import CategoryPosts from '@/components/CategoryPosts'
import SocialWall from '@/components/SocialWall'
import Banners from '@/components/Banners'
import Post from '@/components/Post'
import PhotoAlbum from '@/components/PhotoAlbum'
import ImageSection from '@/components/ImageSection'


export default {
    name: 'LandingPage',
    components: {
        Heading,
        Slider,
        CategoryPosts,
        SocialWall,
        Banners,
        Post,
        PhotoAlbum,
        ImageSection
    },
    computed: {
        ...mapGetters('currentPage', {
            sections: 'sections',
        })
    }
}

</script>

<style lang="sass" scoped>
    @import "@/assets/sass/variables.sass";
    .section.slider,
    .section.banners
        padding: 0
    .section.image,
    .section.heading
        padding-bottom: 0
    .supporters
        margin-bottom: 45px
        h4
            color: $primary
            font-size: 20px
            border-bottom: 1px solid $primary
            margin: 45px 15px
        .wrapper
            margin: 0 15px
        img
            max-width: 80%
            text-align: center
</style>
